import { trackEvent } from '../../_common/client/tracking';
import { CR_FILTER_EVENT, CrFilterEvent } from './customer-review-star-filter.component';

export const addListenersToDeselectButton = (deselectButtonContainer: HTMLElement | null) => {
    registerShowingAndHidingButton(deselectButtonContainer);
    registerOnClickListener(deselectButtonContainer);
};

function registerShowingAndHidingButton(deselectButtonContainer: HTMLElement | null) {
    o_global.eventQBus.on(CR_FILTER_EVENT, (crFilterEvent: CrFilterEvent) => {
        if (isNoFilterSelected(crFilterEvent)) {
            hideDeselectButton(deselectButtonContainer);
        } else {
            showDeselectButton(deselectButtonContainer);
        }
    });
}

function registerOnClickListener(deselectButtonContainer: HTMLElement | null) {
    const deselectButton = deselectButtonContainer?.firstElementChild;
    deselectButton?.addEventListener('click', () => {
        resetFilter();
        trackDeselectButtonClick(deselectButtonContainer);
    });
}

function trackDeselectButtonClick(deselectButtonContainer: HTMLElement | null) {
    const totalNumberOfReviews = deselectButtonContainer!.getAttribute('data-total-number-of-reviews');
    if (totalNumberOfReviews == null) return;
    trackEvent({ review_FilterReview: ['deselect'], review_ReviewCount: [totalNumberOfReviews] });
}

function hideDeselectButton(deselectButtonContainer: HTMLElement | null) {
    deselectButtonContainer?.classList.add('pl_hidden');
}

function showDeselectButton(deselectButtonContainer: HTMLElement | null) {
    deselectButtonContainer?.classList.remove('pl_hidden');
}

function resetFilter() {
    const resetFilterEvent: CrFilterEvent = { filter: 'all' };
    o_global.eventQBus.emit(CR_FILTER_EVENT, resetFilterEvent);
}

function isNoFilterSelected(crFilterEvent: CrFilterEvent) {
    return crFilterEvent.filter === 'all';
}
